module.exports = __webpack_public_path__ + "img/bgR.aa435dcf.png";